var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoBlueWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17 17",
    style: {
      enableBackground: "new 0 0 17 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-info",
    transform: "translate(-2.5 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    className: "st0",
    d: "M19,11c0,4.4-3.6,8-8,8s-8-3.6-8-8s3.6-8,8-8S19,6.6,19,11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    className: "st1",
    d: "M11,15.2v-5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    className: "st2",
    d: "M11,7L11,7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlueWhite);
export default __webpack_public_path__ + "static/media/InfoBlueWhite.c076e031bde0414c5bad35f6013c10e9.svg";
export { ForwardRef as ReactComponent };